<template>
  <div ref="container" class="loader-container">
    <Loading :light="true" />
  </div>
</template>

<script>
import Loading from "@/components/shared/Loading";

export default {
  name: "BottomLoading",
  components: { Loading },
  mounted() {
    let lastTime = 0;

    const observer = new IntersectionObserver(
      entries => {
        if (
          entries[0].intersectionRatio > 0 &&
          entries[0].time - lastTime > 1000
        ) {
          lastTime = entries[0].time;

          this.$emit("appear");
        }
      },
      {
        rootMargin: "0px",
        threshold: 0.7,
      }
    );

    observer.observe(this.$refs.container);
  },
};
</script>

<style lang="scss" scoped>
.loader-container {
  min-height: 100px;
  padding: 32px;

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
